import { render, staticRenderFns } from "./News.html?vue&type=template&id=6b450364&scoped=true&external"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.scss?vue&type=style&index=0&id=6b450364&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b450364",
  null
  
)

export default component.exports